@if (state(); as toast) {
  <div
    class="toast"
    animate.enter="toast-enter"
    animate.leave="toast-leave"
    [class.--has-margin-bottom]="toast.hasMarginBottom"
    role="alert"
    aria-live="polite"
  >
    <i
      [class]="'toast__icon ' + toast.icon"
      [class.--success]="toast.success"
      [class.--error]="!toast.success"
      aria-hidden="true"
    ></i>

    <p class="toast__text">{{ toast.text }}</p>

    @if (toast.dismissButton) {
      <button type="button" class="toast__dismiss" (click)="toastService.dismiss()">OK</button>
    }
  </div>
}
